import { render, staticRenderFns } from "./InstitutionListCardSkeleton.vue?vue&type=template&id=42317902"
import script from "./InstitutionListCardSkeleton.vue?vue&type=script&lang=js"
export * from "./InstitutionListCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports